import { AxiosResponse } from 'axios'

import { ProtectionProduct, ProtectionProductUpdateInput } from '../generated/resolvers'
import request from '../requesters/default'
import {
  CdmAddCaseProtectionProductRequest,
  CdmAddCaseProtectionProductResponse,
  CdmCreateProtectionProductRequest,
  CdmCreateProtectionProductResponse,
  CdmDeleteCaseProtectionProductResponse,
  CdmGetProtectionProductRequest,
  CdmGetProtectionProductResponse,
  CdmUpdateProtectionProductResponse,
} from '../service/luther/model'

// GetProtectionProduct
// https://crm.dev.acreplatforms.co.uk/api_documentation/redoc.html#operation/GetProtectionProduct
export const getProtectionProduct = async (params?: CdmGetProtectionProductRequest) => {
  const response = await request.get<CdmGetProtectionProductResponse>('/protection_product', { params })
  return response?.data
}

// CreateProtectionProduct
// https://crm.dev.acreplatforms.co.uk/api_documentation/redoc.html#operation/CreateProtectionProduct
export const createProtectionProduct = async (body: CdmCreateProtectionProductRequest) => {
  const response = await request.post<CdmCreateProtectionProductResponse>('/protection_product', body)
  return response?.data
}

// AddCaseProtectionProduct
// https://crm.dev.acreplatforms.co.uk/api_documentation/redoc.html#operation/AddCaseProtectionProduct
export const addCaseProtectionProduct = async (protectionId: string, body: CdmAddCaseProtectionProductRequest) => {
  const response = await request.post<CdmAddCaseProtectionProductResponse>(
    `/protection_product/${protectionId}/case`,
    body,
  )
  return response?.data
}

// DeleteCaseProtectionProduct
// https://crm.dev.acreplatforms.co.uk/api_documentation/redoc.html#operation/DeleteCaseProtectionProduct
export const deleteCaseProtectionProduct = async (protectionId: string, caseId: string) => {
  const response: AxiosResponse<CdmDeleteCaseProtectionProductResponse> = await request.delete(
    `/protection_product/${protectionId}/case/${caseId}`,
  )
  return response?.data
}

// UpdateProtectionProduct
// https://crm.dev.acreplatforms.co.uk/api_documentation/redoc.html#operation/UpdateProtectionProduct
export const updateProtectionProduct = async (protectionId: string, body: ProtectionProductUpdateInput) => {
  const response = await request.patch<CdmUpdateProtectionProductResponse>(`/protection_product/${protectionId}`, body)
  return response?.data.protection_product as ProtectionProduct
}
